import axios from 'axios';

/** True when `error` is an axios/fetch cancellation, not a real failure. */
export const isCancelError = (error: unknown): boolean => axios.isCancel(error) || (error as { name?: string })?.name === 'CanceledError';
